var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBoardTick = function SvgBoardTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.18 2.737H5.82A3.356 3.356 0 0 0 2.468 6.09v7.058A3.36 3.36 0 0 0 5.82 16.5h6.352a3.356 3.356 0 0 0 3.353-3.352V6.09a3.345 3.345 0 0 0-3.345-3.353Z",
    fill: "#39B588"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.762 1.5H7.238c-.78 0-1.418.63-1.418 1.41v.705c0 .78.63 1.41 1.41 1.41h3.532c.78 0 1.41-.63 1.41-1.41V2.91c.008-.78-.63-1.41-1.41-1.41ZM8.107 12.713a.556.556 0 0 1-.397-.165l-1.125-1.126a.566.566 0 0 1 0-.795.566.566 0 0 1 .795 0l.728.728 2.602-2.603a.566.566 0 0 1 .795 0 .566.566 0 0 1 0 .795l-3 3a.544.544 0 0 1-.398.165Z",
    fill: "#39B588"
  })));
};
export default SvgBoardTick;